import { render } from "./carruselultimo_ingles.vue?vue&type=template&id=0c3d26f7&scoped=true"
import script from "./carruselultimo_ingles.vue?vue&type=script&lang=js"
export * from "./carruselultimo_ingles.vue?vue&type=script&lang=js"

import "./carruselultimo_ingles.vue?vue&type=style&index=0&id=0c3d26f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3d26f7"]])

export default __exports__